import classNames from 'classnames';
import css from './H6title.module.scss';

export default function H6title({children, cn, isWhite}) {
  return (
    <h6 className={classNames(css.h6, cn, {[css.white]: isWhite})}>{children}</h6>
  );
}